import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoSuppliersGetRes } from "./abst/DtoSuppliersGetRes";

export class DtoSuppliersGetResImple extends DtoSuppliersGetRes {
  public pager = new DtoApiPager();
}
